/**
 * Format: Size guide
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API metaobject response for size guides.
 *
 */
import { getFieldValueByKey, transformEdges } from '~/helpers/graphql'

/**
 * Format size guide metaobject.
 * @param {Object} response - Query response.
 * @returns {Array}
 */
export function formatSizeGuides(response) {
  const sizeGuidesArray = transformEdges(response?.metaobjects)?.map(sizeGuide => {
    const fields = sizeGuide?.fields

    const productTypes = getFieldValueByKey(fields, 'product_types')
      ? JSON.parse(getFieldValueByKey(fields, 'product_types'))
      : []

    const table = getFieldValueByKey(fields, 'table')
    const title = getFieldValueByKey(fields, 'title')
    const generalSizeGuide = getFieldValueByKey(fields, 'general_size_guide')
    const urlPath = getFieldValueByKey(fields, 'url_path')

    return {
      productTypes,
      table,
      title,
      generalSizeGuide,
      urlPath,
    }
  })

  return sizeGuidesArray
}
